import { MakeCloudFunctionSpec } from '@rabbit/firebase/doctype';
import { z } from 'zod';

/**
 * Algolia Transform Function Spec
 * Used by Firebase→Algolia extension to standardize record structure
 * 
 * NOTE: This function is called by Firebase Extension, not client code,
 * so it doesn't use ICF_Base (which requires requestId/apiVersion)
 */

// Input schema for transform function (called by Firebase Extension)
// The Firebase Extension passes the raw document data directly
const ICF_AlgoliaTransformHolding = z.any();

// Output schema for transform function
const OCF_AlgoliaTransformHolding = z.object({
  /** The transformed data that will be saved to Algolia */
  payload: z.record(z.any()),
  /** Algolia object ID */
  objectID: z.string(),
  /** Document ID for consistency */
  docid: z.string(),
  /** Transform metadata for debugging */
  _transform_meta: z.object({
    transformedAt: z.number(),
    firestorePath: z.string().optional(),
    transformFunction: z.string(),
  }).optional(),
});

export const CFC_AlgoliaTransformHolding = MakeCloudFunctionSpec(
  'cfctransformholdingforalgolia',
  ICF_AlgoliaTransformHolding,
  OCF_AlgoliaTransformHolding
);

